import { useUnpaidBanner } from "components/context/UnpaidBannerContext";
import UnpaidTrialBanner from "./UnpaidTrialBanner";
import { SxProps } from "@mui/material";

export default ({ sx }: { sx?: SxProps }) => {
  const { shouldShowBanner, daysLeft } = useUnpaidBanner();

  if (!shouldShowBanner) {
    return null;
  }

  return <UnpaidTrialBanner daysLeft={daysLeft} sx={sx} />;
};
